import Hijack from 'components/Hijack/Hijack';

const HijackPage = () => {
	return <Hijack />;
};

export default HijackPage;
